import { getRequest, postRequest, deleteRequest } from '../core/apiRequests';

export const INQUIRY_MESSAGES = [
  {
    id: 'new_inquiry',
    name: 'New Inquiry',
    title: 'New Inquiry Message',
    defaultMessage:
      'Hello :name:, thank you for your interest in the :model_name:. :associate: will be in touch with any updates regarding availability.',
  },
  {
    id: 'inquiry_followup',
    name: 'Inquiry Follow-up',
    title: 'Inquiry Follow-up Message',
    defaultMessage:
      'Hello :name:, just checking in on your interest in the :model_name:. Please let us know if you have any questions.\n:model_link:',
  },
];

// Maps backend type values to frontend keys
const TYPE_TO_KEY = {
  IMMEDIATE: 'new_inquiry',
  FOLLOW_UP: 'inquiry_followup',
};

const KEY_TO_TYPE = {
  new_inquiry: 'IMMEDIATE',
  inquiry_followup: 'FOLLOW_UP',
};

export const getInquiryAutoMessages = async () => {
  const response = await getRequest({
    params: ['rolex-inquiries', 'auto-messages'],
    loadingStatusOff: true,
  });
  const messages = Array.isArray(response) ? response : [];
  const result = {};
  messages.forEach(msg => {
    const key = TYPE_TO_KEY[msg.type];
    if (key) {
      result[key] = {
        id: msg.id,
        type: key,
        msg: msg.msg,
        action_interval: msg.action_interval,
        action_scale: msg.action_scale,
        repeats: msg.repeats,
        active: msg.active,
      };
    }
  });
  return result;
};

export const updateInquiryAutoMessage = async (id, data, msgType) => {
  const backendType = KEY_TO_TYPE[msgType];
  const payload = {
    msg: data.msg,
    actionInterval: data.action_interval,
    actionScale: data.action_scale,
    type: backendType,
    repeats: backendType === 'FOLLOW_UP' ? 1 : 0,
    active: data.active,
  };
  if (id) {
    payload.id = id;
  }
  const response = await postRequest({
    params: ['rolex-inquiries', 'auto-messages'],
    data: payload,
    loadingStatusOff: true,
  });
  return response;
};

export const deleteInquiryAutoMessage = async autoMessageId => {
  const response = await deleteRequest({
    params: ['rolex-inquiries', 'auto-messages', autoMessageId],
    loadingStatusOff: true,
  });
  return response;
};
